<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{title}}</h4>
  <button type="button" tabindex="-1" class="close" aria-describedby="modal-title" (click)="modal.dismiss('dismiss')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  {{content}}
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="modal.close('ok')">Ok</button>
</div>
